// Version : 0.0.1
// Author : SABARI

import TransferBranchTypes from './transfer-branch.types';

/************** CREATE DUPLICATE CENTER GROUP START ******************/
export const createDuplicateCenterGroupStart = (getData: any) => ({
	type: TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_START,
	payload: getData,
});

export const createDuplicateCenterGroupSuccess = (successData: any) => ({
	type: TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_SUCCESS,
	payload: successData,
});

export const createDuplicateCenterGroupFailure = (failureData: unknown) => ({
	type: TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_FAILURE,
	payload: failureData,
});

export const createDuplicateCenterGroupResponseResetStart = () => ({
	type: TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_RESPONSE_RESET_START,
});

export const createDuplicateCenterGroupResponseChanged = () => ({
	type: TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_RESPONSE_CHANGED,
});
/************** CREATE DUPLICATE CENTER GROUP END ******************/

/************** MEMBER BRANCH TO CENTER TRANSAFER START ******************/
export const addBranchToCenterStart = (getData: any) => ({
	type: TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_START,
	payload: getData,
});

export const addBranchToCenterSuccess = (successData: any) => ({
	type: TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_SUCESS,
	payload: successData,
});

export const addBranchToCenterFailure = (failureData: unknown) => ({
	type: TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_FALIURE,
	payload: failureData,
});

export const addBranchToCenterResponseStart = () => ({
	type: TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_RESPONSE_RESET_START,
});

export const addBranchToCenterResponseChanged = () => ({
	type: TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_RESPONSE_CHNAGED,
});
/************** MEMBER BRANCH TO CENTER TRANSAFER END ******************/

/************** TRANSFER MEMBER LIST START ******************/
export const transferMemberListStart = (getData: any) => ({
	type: TransferBranchTypes.TRANSFER_MEMBER_LIST_START,
	payload: getData,
});

export const transferMemberListSuccess = (successData: any) => ({
	type: TransferBranchTypes.TRANSFER_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const transferMemberListFailure = (failureData: unknown) => ({
	type: TransferBranchTypes.TRANSFER_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const transferMemberListResponseResetStart = () => ({
	type: TransferBranchTypes.TRANSFER_MEMBER_LIST_RESPONSE_RESET_START,
});

export const transferMemberListResponseChanged = () => ({
	type: TransferBranchTypes.TRANSFER_MEMBER_LIST_RESPONSE_CHANGED,
});
/************** TRANSFER MEMBER LIST END ******************/

/************** FETCH TRANSFER CENTER LIST START ******************/
export const fetchTransferCenterListStart = (getData: any) => ({
	type: TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_START,
	payload: getData,
});

export const fetchTransferCenterListSuccess = (successData: any) => ({
	type: TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_SUCCESS,
	payload: successData,
});

export const fetchTransferCenterListFailure = (failureData: unknown) => ({
	type: TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_FAILURE,
	payload: failureData,
});

export const fetchTransferCenterListResponseResetStart = () => ({
	type: TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_RESPONSE_RESET_START,
});

export const fetchTransferCenterListResponseChanged = () => ({
	type: TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_RESPONSE_CHANGED,
});
/************** FETCH TRANSFER CENTER LIST END ******************/
